var React = require('react');

function HubtypePointsBgTriangle (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M2 63.2324L79.9956 94.3608M2 63.2324L51.4599 53.407M2 63.2324L79.1107 25.6475M79.9956 94.3608L51.4599 53.407M79.9956 94.3608L79.1107 25.6475M51.4599 53.407L79.1107 25.6475","stroke":"#553E6B"}));
}

HubtypePointsBgTriangle.defaultProps = {"width":"110","height":"104","viewBox":"0 0 110 104","fill":"none"};

module.exports = HubtypePointsBgTriangle;

HubtypePointsBgTriangle.default = HubtypePointsBgTriangle;
